import React from 'react';
import { isNative, isIOS } from '../utils/platformUtils';

const StatusBar = () => {
  // On native iOS, the status bar is handled by a native UIView overlay
  // (see AppDelegate.swift) which is completely independent of the WebView
  // This ensures it stays fixed even when keyboard appears
  // 
  // For PWA iOS, we still need the React component (handled by CSS pseudo-element)
  // For other platforms, return null
  
  // Only render for PWA iOS (native iOS uses native overlay)
  if (isNative() && isIOS()) {
    return null; // Native iOS uses native overlay, no React component needed
  }
  
  // For non-native platforms, return null (PWA iOS uses CSS pseudo-element)
  return null;
};

export default StatusBar;
